import React from 'react'

import RadioToggle from '../../generic/toggles/radioToggle'
import Error from '../../generic/Error'

export default ({ isIneligible, isError, saveQuestionResponse, getQuestionResponse, amQ, addImpressions }) => {
  const amR = getQuestionResponse(amQ).v

  return (
    <>
      <RadioToggle
        pills={['Yes', 'No']}
        testId={'vd-bt-vehiclemodifications'}
        selectedIndex={amR}
        onClickItem={(i, isSelected) => {
          saveQuestionResponse(amQ, i)
        }}
      />
      {!isIneligible && <Error isError={isError} id={'vehiclemodifications-error'} testId={`vd-lb-vehiclemodifications-error`} text={'Please select whether your vehicle has modifications.'} />}
    </>
  )
}
